<base-support-modal [title]="title" [btnOkClass]="'btn-success'" [btnOkLabel]="'Подтвердить'" (onOk)="ok()" >
	Прервать публикацию {{domainUrl}}
	<br />
</base-support-modal>
